import React, { useState, useEffect } from "react";
import { apiGet, apiPost } from "api/callApi";
import { Button } from "InnoUI/components";
import InnoIcons from "InnoUI/innoicons";
import { ProjectDropdown } from "components";
import theme from "theme";
import SC from "./style";
import UserTable from "views/AdminSettings/Users/UserTable";
import { innoTableConfigsecond } from "utils/config";
import { showAlert } from "utils/helper/index.js";

function AssignUser(props) {
  const { onClose, userdata, project = null } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [currentProject, setCurrentProject] = useState(project?.id || null);
  const [currentPageP, setCurrentPageP] = useState(1);
  const [totalData, setTotalData] = useState(0);

  const handleProjectChange = (selectedProject) => {
    setCurrentProject(selectedProject);
    getprojectAssignUser(selectedProject);
  };

  const getprojectAssignUser = async (projectId) => {
    if (!projectId) {
      setSelectedItems([]);
      return;
    }
    try {
      setLoading(true);
      const response = await apiGet(
        `/v1/users/assignroletouser/${userdata.id}/${projectId}`,
        false
      );
      const assignedRoles = response.data.map((user) => user.userId);
      setSelectedItems(assignedRoles);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const manageAssignProjectUser = async () => {
    if (!currentProject) {
      showAlert({
        title: "Please select a project",
        text: "You need to choose a project first",
        icon: "warning",
      });
      return;
    }

    try {
      setLoading(true);
      const response = await apiPost(
        `/v1/users/assignroletouser/${userdata.id}`,
        {
          users: selectedItems,
          projectId: currentProject,
        }
      );
      showAlert({ title: "Success", text: response?.message, icon: "success" });
      setLoading(false);
      // await fetchData();
    } catch (error) {
      console.log("error", error);
      showAlert({
        title: "Error",
        text: error?.response.data.message,
        icon: "error",
      });
      setLoading(false);
    }
  };

  const getAllUser = async () => {
    try {
      setLoading(true);
      const response = await apiGet(`/v1/getallusers`, false);
      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllUser();
    if (currentProject) {
      getprojectAssignUser(currentProject);
    }
  }, []);

  const onSelectionChange = (id, selectAll = false) => {
    if (!currentProject) {
      showAlert({
        title: "Please select a project",
        text: "You need to choose a project first",
        icon: "warning",
      });

      return;
    }

    if (id === "clear") {
      setSelectedItems([]);
      return;
    }

    const availableRoleIds = data.map((item) => item.id);
    setSelectedItems((prevSelectedItems) => {
      if (selectAll) {
        return availableRoleIds;
      }

      const isValidRole = availableRoleIds.includes(id);
      if (!isValidRole) {
        console.warn("Invalid Role ID:", id);
        return prevSelectedItems;
      }

      const updatedSelectedItems = prevSelectedItems.includes(id)
        ? prevSelectedItems.filter((item) => item !== id)
        : [...prevSelectedItems, id];

      return updatedSelectedItems.filter((item) =>
        availableRoleIds.includes(item)
      );
    });
  };

  const tableConfig = {
    draggable: false,
    selection: true,
    expandable: true,
    addNew: true,
    search: true,
    action: false,
    sno: false,
    divBorder: true,
    // pagination: {
    //   total: totalData,
    //   current: currentPageP,
    //   serverSide: true,
    //   defaultCurrent: currentPageP,
    //   pageSize: innoTableConfigsecond.pageSize,
    //   onChange: (page) => setCurrentPageP(page),
    //   showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    //   itemRender: (_, type, originalElement) => {
    //     if (type === "prev") {
    //       return <a>Previous</a>;
    //     }
    //     if (type === "next") {
    //       return <a>Next</a>;
    //     }
    //     return originalElement;
    //   },
    // },
    pagination: false,
  };

  return (
    <>
      <SC.DrawerTitlesContainer>
        <SC.DrawerTitles>{`Assign ${userdata.role} (Role) to Users`}</SC.DrawerTitles>
        <SC.CloseIcon>
          <InnoIcons.CloseIcon onClick={onClose} />
        </SC.CloseIcon>
      </SC.DrawerTitlesContainer>

      {/* {loading && <Loader />} */}

      <div
        style={{
          padding: "20px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <ProjectDropdown
          defaultValue={currentProject}
          onChange={handleProjectChange}
        />
        <div style={{ display: "flex", gap: "10px" }}>
          <Button
            caption="Cancel"
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: "#f7f9f7",
              color: theme.colors.white,
              minWidth: "100px",
              borderRadius: "3px",
              height: "30px",
              fontSize: "12px",
            }}
            onClick={onClose}
          />
          <Button
            caption={"Save"}
            type="submit"
            isLoading={loading}
            onClick={manageAssignProjectUser}
            color="white"
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "100px",
              height: "30px",
              borderRadius: "3px",
            }}
            disabled={data.length == 0}
          />
        </div>
      </div>
      <div>
        <UserTable
          tableConfig={tableConfig}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          userProjectId={currentProject}
          hideColumns={["roleNames", "cell", "userType", "createdAt"]}
          allowEdit={false}
          currentPageP={currentPageP}
          setTotalData={setTotalData}
        />
      </div>
    </>
  );
}

export default AssignUser;
